import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: #ffffff;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media (max-width: 576px) {
    font-size: 1.25rem;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  line-height: 1.5;
  color: #ffffff;

  @media (max-width: 576px) {
    font-size: 0.875rem;
  }
`;

export const Section = styled.section`
  &.section {
    background: linear-gradient(to right, #272727, #8D8D8D);
    padding-top: 3rem;
    position: relative;

    @media (min-width: 992px) {
      padding-top: 4rem;
    }
  }
`;